export interface IOfferBuilding {
  cargoLiftsCount?: number | null;
  passengerLiftsCount?: number | null;
  liftTypes?: Array<IBuildingLiftType> | null;
  cranageTypes?: Array<IBuildingCranageType> | null;
  floorsCount?: number | null;
  buildYear?: number;
}

export interface IBuildingLiftType {
  /** Тип */
  type: ELiftType;
  /** Количество */
  count: number | null;
}

export interface IBuildingCranageType {
  /** Тип */
  type: ECranageType;
  /** Количество */
  count: number | null;
  /** Грузоподъёмность */
  loadCapacity: number | null;
}

export enum ELiftType {
  /** Лифт */
  lift = 'lift',
  /** Траволатор */
  travelator = 'travelator',
  /** Эскалатор */
  escalator = 'escalator',
  /** Грузовой */
  cargo = 'cargo',
  /** Тельфер */
  telpher = 'telpher',
  /** Пассажирский */
  passenger = 'passenger',
}

export enum ECranageType {
  /** Мостовой кран */
  overhead = 'overhead',
  /** Кран-балка */
  beam = 'beam',
  /** Ж/д кран */
  railway = 'railway',
  /** Козловой кран */
  gantry = 'gantry',
}
